import { useQuery } from '@apollo/client';
import type { AuthProviderConfig } from '@auth/domain';
import { GET_AUTH_PROVIDERS } from '@auth/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface AuthProvidersResponse {
  authProviders: {
    providers: AuthProviderConfig[];
  };
}

/**
 * Hook to fetch authentication providers
 */
export function useAuthProviders() {
  const { data, loading, error, refetch } = useQuery<AuthProvidersResponse>(GET_AUTH_PROVIDERS, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true, // This makes loading true during refetch
  });

  const providers = useMemo(() => data?.authProviders?.providers || [], [data]);

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    providers,
    loading,
    errors,
    refetch,
  };
}
